import React from 'react';
// withRouter is imported so you have access to the history and match props
import { withRouter } from 'react-router-dom';

import './menu-item.scss';

const MenuItem = ({ title, imageUrl, size, history, match, linkUrl }) => (
  <div className={`${size} menu-item`} onClick={ () => history.push(`${match.url}${linkUrl}`) }>
    <div
      className='background-image'
      style={{
        backgroundImage: `url(${imageUrl})`
      }}
    />
    <div className='content'>
      <h1 className='title'>{title.toUpperCase()}</h1>
      <span className='subtitle'>SHOP NOW</span>
    </div>
  </div>
);

export default withRouter(MenuItem);
